"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBasicAuthHeader = void 0;
var encode_1 = require("../tools/encode");
function generateBasicAuthHeader(username, password) {
    var encoded = (0, encode_1.toBase64)("".concat(username, ":").concat(password));
    return "Basic ".concat(encoded);
}
exports.generateBasicAuthHeader = generateBasicAuthHeader;
